<template>
  <CardModule class="mt-6" title="Config. Vendas">
    <v-row>
      <v-col cols="6">
        <v-radio-group
          v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_vendas"
          class="mt-0"
          hide-details
        >
          <template v-slot:label>
            <div class="">Rede de Vendas:</div>
          </template>
          <v-radio
            value="COMPARTILHADA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Rede Compartilhada<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="PRIVADA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Rede Exclusiva<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row
      v-if="
        $loja_gerenciar.cadastro.configuracoes_rede.rede_vendas == 'PRIVADA'
      "
    >
      <v-row class="mt-2">
        <v-col cols="6">
          <span> Canais de Venda - Rede Exclusiva: </span>
          <v-checkbox
            v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_privada"
            label="Pontos de Venda (POS)"
            class="checkbox-redes"
            value="PDV_POS"
          ></v-checkbox>
          <v-checkbox
            v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_privada"
            label="Ponto de Venda (QRCode)"
            class="checkbox-redes"
            value="PDV_QRCODE"
          >
          </v-checkbox>
          <div class="d-flex">
            <v-checkbox
              v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_privada"
              label="E-commerce"
              class="checkbox-redes"
              value="ECOMMERCE"
            >
            </v-checkbox>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div class="info-tool mr-5 mt-5" v-bind="attrs" v-on="on">
                  <InfoIcon />
                </div>
              </template>
              <span
                >Importante: ao marcar essa opção será gerado subdomínio
                específico para essa loja. Ex: slug.eleven360.com</span
              >
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="2">
          <v-row>
            <BaseTextField
              label="Desconto neste canal"
              hide-details
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_POS
              "
              class="pt-11"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row>
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_QRCODE
              "
              class="pt-6"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row>
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              class="pt-6"
              placeholder="0%"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.ECOMMERCE
              "
              type="number"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row
      v-if="
        $loja_gerenciar.cadastro.configuracoes_rede.rede_vendas ==
        'COMPARTILHADA'
      "
    >
      <v-row class="mt-2">
        <v-col cols="6">
          <span>
            <span>Canais de Venda - Rede Compartilhada:</span>
          </span>
          <v-checkbox
            v-model="
              $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
            "
            label="Pontos de Venda (POS)"
            class="checkbox-redes"
            value="PDV_POS"
          >
          </v-checkbox>
          <v-checkbox
            v-model="
              $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
            "
            label="Ponto de Venda (QRCode)"
            class="checkbox-redes"
            value="PDV_QRCODE"
          >
          </v-checkbox>
          <v-checkbox
            v-model="
              $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
            "
            label="Marketplace"
            class="checkbox-redes"
            value="MARKETPLACE"
          >
          </v-checkbox>
          <div class="d-flex">
            <v-checkbox
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
              "
              label="E-commerce"
              class="checkbox-redes"
              value="ECOMMERCE"
            >
            </v-checkbox>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div class="info-tool mr-5 mt-5" v-bind="attrs" v-on="on">
                  <InfoIcon />
                </div>
              </template>
              <span
                >Importante: ao marcar essa opção será gerado subdomínio
                específico para essa loja. Ex: slug.eleven360.com</span
              >
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="2">
          <v-row>
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_POS
              "
              class="pt-11"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row class="mt-5">
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_QRCODE
              "
              class="pt-5"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row class="mt-5">
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.MARKETPLACE
              "
              class="pt-5"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row class="mt-5">
            <BaseTextField
              hide-details
              label="Desconto neste canal"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.ECOMMERCE
              "
              class="lojas-gerenciar-rede-compartilhada-desconto pt-5"
              placeholder="0%"
              type="number"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-radio-group
          v-model="$loja_gerenciar.cadastro.dados_cadastrais.tipo_slug"
          hide-details
        >
          <template v-slot:label>
            <div>Link da Loja:</div>
          </template>
          <v-radio
            value="DEFAULT"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Padrão<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="CUSTOM"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Personalizado<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mb-n7">
        <BaseTextField
          counter="15"
          suffix=".eleven360.com"
          placeholder="Digite o endereço virtual da loja."
          label="Link da Loja"
          hint="Exemplo: exemplo.eleven360.com"
          :rules="defaultSlug ? [] : [rules.required]"
          :disabled="defaultSlug"
          v-model="$loja_gerenciar.cadastro.dados_cadastrais.slug_loja"
          type="tel"
        />
      </v-col>
      <v-col cols="12" class="mb-7">
        <v-checkbox
          v-model="$loja_gerenciar.cadastro.configuracoes_rede.validar_cpf"
          label="Integração Assertiva - Validação CPF"
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "../forms/BaseTextField.vue";
import mixins from "@/mixins";

const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-rede-compartilhada",
  mixins: [LojasGerenciarMixins, formRules],
  data() {
    return {
      addPdv: [],
    };
  },
  components: {
    CardModule,
    InfoIcon: () => import("@/components/icons/InfoIcon.vue"),
    BaseTextField,
  },
  computed: {
    defaultSlug() {
      return this.$loja_gerenciar.cadastro.dados_cadastrais.tipo_slug ==
        "DEFAULT"
        ? true
        : false;
    },
  },
};
</script>
<style scoped>
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.325rem;
  cursor: pointer;
}
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.checkbox-redes {
  margin-right: 0.625rem;
  margin-left: 0.625rem;
}

.lojas-gerenciar-rede-compartilhada-desconto {
  width: 100%;
  border-radius: 0.625rem;
}
</style>
